export const environment = {
  production: true,
  companyMetadata: {
    on_sale_generated_redirect_sale: true
  },
  companyConfiguration: {
    locale: 'es-ES',
    currency: 'EUR'
  },
  BEE_CLIENT_ID: "26d29c5f-0fbe-4656-a1fe-3ddf2b153a6e",
  BEE_CLIENT_SECRET: "ihiPkAAl4ByiYR6X8WkBQiaOnIYGLbkXswtUAJacwCctDZvhJG7O",
  BEE_CLIENT_MAIL_ID: "2c559791-5e7b-4377-a6f6-ff3e884e47d0",
  BEE_CLIENT_MAIL_SECRET: "nj0PvXGQbehbxsJ1HpA2O4aIqCEzFwDFqCkex8RFhhtmxEh3Z3fS"
};
